import React from "react";
import { ChevronDown, LucideIcon } from "lucide-react";

interface ProjectFormSectionProps {
  id: string;
  title: string;
  description: string;
  icon: LucideIcon;
  iconGradient: string;
  isActive: boolean;
  onToggle: () => void;
  badge?: string;
  children: React.ReactNode;
}

const ProjectFormSection: React.FC<ProjectFormSectionProps> = ({
  id,
  title,
  description,
  icon: Icon,
  iconGradient,
  isActive,
  onToggle,
  badge,
  children,
}) => {
  return (
    <div
      id={id}
      className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden"
    >
      <div
        className="p-4 border-b border-gray-100 cursor-pointer hover:bg-gray-50 transition-colors"
        onClick={onToggle}
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div
              className={`w-10 h-10 rounded-xl bg-gradient-to-br ${iconGradient} flex items-center justify-center`}
            >
              <Icon className="w-5 h-5 text-white" />
            </div>
            <div>
              <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
              <p className="text-sm text-gray-500">{description}</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            {badge && <span className="text-sm text-gray-500">{badge}</span>}
            <ChevronDown
              className={`w-5 h-5 text-gray-400 transition-transform ${
                isActive ? "rotate-180" : ""
              }`}
            />
          </div>
        </div>
      </div>

      {isActive && <div className="p-6 space-y-6">{children}</div>}
    </div>
  );
};

export default ProjectFormSection;
